import '../style.css';

const SuccessResponse = ()=>{
    
    return (
        <div className='container'>
            <div className='response-overlay'>
            <div className='response-box'>
            <div className='success-response'>
    <p>Verification Successful</p>
    <div className='description'>Thank you for completing CLEAR ID Verification. <br/><br/>
    You will receive next steps from your Hiring Manager.</div>
        
    </div>
            </div>
            </div>
    </div>

    )
    
};

export default SuccessResponse;